import {QuizData} from "../../Shared/Model/QuizData";
import {useContext, useState} from "react";
import QuizStateFactory from "../Factory/QuizStateFactory";
import Homepage from "../../Shared/Page/Homepage";
import Button from "../../Shared/Components/Button";
import QuizPlay from "./QuizPlay";
import ThemeContext from "../../Shared/Theme/ThemeContext";
import {Diploma} from "../../Shared/Components/Diploma";
import {GameState} from "../../Shared/Model/GameState";
import {GameFinish} from "../../Shared/Components/GameFinish";
import StringFactory from "../Factory/StringFactory";

export default function QuizContent(props: { data: QuizData }) {
    const [state, setState] = useState<GameState>(QuizStateFactory.homepage())
    const theme = useContext(ThemeContext)

    switch (state.screen) {
        case "homepage": return <Homepage
            title={props.data.settings.name}
            subtitle={props.data.settings.text}
            buttons={ props.data.list.map((q, i) =>
                <Button
                    key={q.id}
                    color={q.type === "memo" ? "orange" : "default"}
                    icon={props.data.list.length > 1 && (q.id !== "pbt-quiz" && q.id !== "pot-quiz") ? (i === 0 ? "young" : "old") : null}
                    title={props.data.list.length > 1 ? q.name : "Start"}
                    onClick={() => {
                        if (q.id === 'pbt-quiz') {
                            theme.diplomaImage = 'images/pot-quiz/diploma-bon.png'
                            theme.backgroundImage = 'images/pot-quiz/background-bon.png'
                        } else if (q.id === 'pot-quiz') {
                            theme.diplomaImage = 'images/pot-quiz/diploma.png'
                            theme.backgroundImage = 'images/pot-quiz/background.png'
                        }
                        setState(QuizStateFactory.play(q))
                    }}
                />
            ) }
            onCancel={ () => {} }
        />
        case "play": return <QuizPlay
            quiz={state.quiz}
            settings={props.data.settings}
            onFinish={score => setState(QuizStateFactory.finish(StringFactory.quizTitle(state.quiz, props.data.settings), props.data.settings.dictionary[state.quiz.id], score))}
            onCancel={() => setState(QuizStateFactory.homepage)}
        />
        case "finish": return <GameFinish
            title={state.title}
            hint={"Rozwiązałeś cały quiz, Odbierz swój dyplom!"}
            score={state.score}
            onCancel={() => setState(QuizStateFactory.homepage)}
            onEnterName={name => setState(QuizStateFactory.diploma(name, state.title, state.text, state.score))}
        />
        case "diploma": return <Diploma
            title={state.title}
            text={state.text}
            name={state.name}
            score={state.score}
            onCancel={() => setState(QuizStateFactory.homepage)}
        />
    }
}
